import { render, staticRenderFns } from "./AiAssistantSettings.vue?vue&type=template&id=495cf33f"
import script from "./AiAssistantSettings.vue?vue&type=script&lang=js"
export * from "./AiAssistantSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports